<template>
    <popper
    v-if="!isMobile"
    ref="popper"
    trigger="clickToToggle"
    :options="{
      placement: 'right',
      modifiers: {
        offset: { offset: '25px,10px' },
        flip: {
          behavior: ['right', 'left', 'right-end']
        },
      }
    }"
    @show="onShow"
    @hide="onHide"
    boundaries-selector="body"
    :disabled="disabled"
  >
    <div class="popper adaptive-popper popover__content" :class="{ autobox }" :style="{ height: !autobox && `${height}px`, width: !autobox && `${width}px` }">
      <slot name="top-button"/>
      <perfect-scrollbar v-scroll-stop v-if="!autobox && !noscrollbar">
        <div class="pr-3 h-100">
          <slot name="content"/>
        </div>
      </perfect-scrollbar>
      <div v-else>
        <div class="h-100">
          <slot name="content"/>
        </div>
      </div>
      <slot name="button"/>
      <div class="mobile-popover-title">
        {{ description }}
        <span v-if="!!buttonCallback" class="mini-button" @click="buttonCallback">
          Перейти
        </span>
      </div>
    </div>

    <div slot="reference" style="line-height: 0">
      <slot name="element" v-bind:active="isActive"/>
    </div>
  </popper>

  <div v-else>
    <div @click="toggle">
      <slot name="element" v-bind:active="isActive"/>
    </div>
    <transition name="fade" mode="out-in">
      <div class="mobile-popover-wrapper" v-if="isActive" @click.self="hideMobile">
        <div class="mobile-popover" :class="{ hide: isHiding, autobox }">
          <div class="mobile-popover__header">
            <p class="mobile-popover-title">{{ title }}</p>
            <div class="mobile-popover__hide-arrow" @click="hideMobile">
              <svg class="mobile-popover-arrow" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 1.5L6.5 6.5L11.5 1.5" stroke="#25265E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="popover__content-mobile">
            <slot name="top-button"/>
            <perfect-scrollbar v-scroll-stop v-if="!noscrollbar">
              <div class="pr-3" v-scroll-stop>
                <slot name="content" v-bind:mobile="isMobile"/>
              </div>
            </perfect-scrollbar>
            <div v-else>
              <slot name="content" v-bind:mobile="isMobile"/>
            </div>
            <slot name="button"/>
            <div class="mobile-popover-title mobile-popover-custom-title">
              {{ description }}
              <div v-if="!!buttonCallback" class="mini-button mini-button--mobile" @click="buttonCallback">
                Перейти
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '265',
    },
    width: {
      type: String,
      default: '400',
    },
    autobox: {
      type: Boolean,
      default: false,
    },
    noscrollbar: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    buttonCallback: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isActive: false,
    isHiding: false,
  }),
  watch: {
    isActive(value) {
      if (!this.isMobile) return;
      if (value) this.$emit('show')
      else this.$emit('hide')
    }
  },
  computed: {
    isMobile() {
      return this.$mq !== 'xl' && this.$mq !== 'lg' && this.$mq !== 'md';
    }
  },
  methods: {
    toggle() {
      if (this.disabled && this.isActive) {
        return;
      }
      this.isActive ^= true
    },
    show() {
      if (this.disabled) {
        return;
      }
      if (!this.$refs.popper) return;
      this.$refs.popper.showPopper = true;
    },
    onShow() {
      if (this.disabled) {
        return;
      }
      this.isActive = true;
      this.$emit('show')
    },
    onHide() {
      this.isActive = false;
      this.$emit('hide')
    },
    hideMobile() {
      this.isHiding = true;
      setTimeout(() => {
        this.isActive = false;
        this.isHiding = false;
      }, 400);
    }
  }
}
</script>

<style lang="scss">
.popper[x-placement^="right"] .popper__arrow {
  border-width: 10px 10px 10px 0;
  left: -10px;
  right: unset;
  filter: drop-shadow(-10px 0px 26px black);
}
.popper[x-placement^="left"] .popper__arrow {
  border-width: 10px 0 10px 10px;
  right: -10px;
  left: unset;
  filter: drop-shadow(-10px 0px 26px black);
}
</style>

<style lang="scss" scoped>
.adaptive-popper {
  width: 400px;
  height: 265px;

  background: #FFFFFF;
  box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  user-select: none;
  max-height: unset !important;

  &.autobox {
    width: unset;
    height: unset;
  }
}

.mobile-popover-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  background: rgba(0, 0, 0, 0.2);
  z-index: 11;
}
.mobile-popover {
  @keyframes show {
    from { transform: translateY(100%) }
    to { transform: translateY(0%) }
  }
  width: 100%;
  background: #FFFFFF;
  height: 440px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  position: absolute;
  bottom: 0;
  padding: 25px;
  transform: translateY(0%);
  transition: all .35s ease-in;
  animation: show .35s ease-out;
  display: flex;
  flex-direction: column;

  &.hide {
    transform: translateY(100%);
  }
  &.autobox {
    height: unset;
  }
}
.mobile-popover__header {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  height: 20px;
  margin-bottom: 15px;
  p {
    margin: 0;
  }
}
.mobile-popover-title {
  font-size: 14px;
  color: #787993;
  width: 100%;
  text-align: center;
}
.popover__content {
  max-height: 100%;
  padding: 25px;
  display: flex;
  flex-direction: column;
  .ps {
    height: 100%;
  }
}
.popover__content-mobile {
  max-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .ps {
    height: 100%;
  }
}
.mobile-popover__hide-arrow {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
}

.mini-button {
  background: #F68C1E;
  color: #fff;
  font-size: 12px;
  text-align: center;
  padding: 3px 6px;
  border-radius: 6px;
  max-width: 100px;
  margin: 10px auto 0;

  &--mobile {
    font-size: 17px;
    padding: 8px 6px;
    width: 100%;
    min-width: 100%;
    margin: 15px auto 0;
  }
}
.mobile-popover-custom-title {
  text-align: center;
  padding-top: 10px;
  font-size: 17px;
}
</style>
